<script setup>
import BaseModal from "@/components/global/modals/BaseModal.vue";
import {useStore} from "vuex";
import {computed} from "vue";
import DefaultButton from "@/components/global/buttons/DefaultButton.vue";
import AwaitingInstallationContent
  from "@/components/onsiteOptimizer/installation/modals/partials/AwaitingInstallationContent.vue";

const emit = defineEmits(['close']);
const store = useStore();
const isAdmin = computed(() => store.getters['user/isAdmin']);
const user = computed(() => store.getters['user/user']);

const isSoftwarePlus = computed(() => user?.value.active_website.done_with_you);

const handleClose = () => {
  if (!isAdmin.value) {
    return;
  }

  emit('close');
}
</script>

<template>
  <BaseModal
    :hide-close-button="!isAdmin"
    @close="handleClose"
  >
    <template #heading>
      We’re On It!
    </template>
    <div class="tw-flex tw-flex-col tw-justify-center tw-gap-2 tw-text-slate-200">
      <div class="tw-w-full">
        <AwaitingInstallationContent :is-software-plus="isSoftwarePlus" />
      </div>
    </div>
    <template #footer>
      <div class="tw-flex tw-w-full tw-justify-center">
        <div class="tw-w-1/3">
          <DefaultButton
            element="a"
            class="tw-mt-5"
            size="md"
            :href="`${isSoftwarePlus ? 'https://calendly.com/hikeseo/support-new-customer-call' : 'https://calendly.com/hike-seo/meet-your-account-managers' }`"
            target="_blank"
          >
            Book Your 1-to-1 Call
          </DefaultButton>
        </div>
      </div>
    </template>
  </BaseModal>
</template>
